import { createApp } from 'vue';
import LocalDatabase from '@/includes/db';
import schemas from '@/includes/db/schemas';
import mitt from 'mitt';
import type { Vue3TouchEventsOptions } from 'vue3-touch-events';
import Vue3TouchEvents from 'vue3-touch-events';
import App from './App.vue';
import './registerServiceWorker';
import router from './includes/router';
import store from './includes/store';

export const SCHEMA_VERSION = 6;
export const DB_NAME = 'thdctech-wordbook-storage';
LocalDatabase.initializeDatabase(schemas, DB_NAME, SCHEMA_VERSION)
  .then(() => {
    const emitter = mitt();
    const app = createApp(App);
    app.config.globalProperties.emmitter = emitter;
    app
      .use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
        disableClick: false,
      })
      .use(store)
      .use(router)
      .mount('#app');
  });
